import { deleteLineItem } from "@lib/data/cart"
import { Spinner, Trash } from "@medusajs/icons"
import { clx } from "@medusajs/ui"
import { useState } from "react"

const DeleteButton = ({
  variantId,
  cartItemIds,
  children,
  className,
  refetchCart,
  disabled = false,
  playerId,
}: {
  variantId: string
  cartItemIds: number[]
  children?: React.ReactNode
  className?: string
  refetchCart?: () => void
  disabled?: boolean
  playerId?: string
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async (cartItemIds: number[], variantId: string) => {
    if (disabled) return
    setIsDeleting(true)
    await deleteLineItem(cartItemIds, variantId)
      .then(async () => {
        await setIsDeleting(false)
        if (refetchCart) {
          await refetchCart()
        }
      })
      .catch(async (err) => {
        await setIsDeleting(false)
        console.error("Failed to delete line item: ", err)
      })
  }

  return (
    <div
      className={clx(
        "flex justify-between items-center text-small-regular",
        className
      )}
    >
      <button
        className={clx(
          "flex gap-x-1 text-ui-fg-subtle hover:text-red-500",
          disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        )}
        onClick={() => handleDelete(cartItemIds, variantId)}
        disabled={disabled}
      >
        {isDeleting ? <Spinner className="animate-spin" /> : <Trash />}
        <span>{children}</span>
      </button>
    </div>
  )
}

export default DeleteButton
